<template >
  <BarChart
  :chartData="chartData"
  :options="chartOptions"
  :height="chartHeight"
  :width="chartWidth"
  />
</template>
<script>
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.register(...registerables,ChartDataLabels);

export default {
  name: 'TopTwentyChart',
  components: { BarChart },
  props: {
    chartData: {
      type: Object,
      default() {
        return {};
      }
    },
    maxCount: {
      type: Number,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chartDatasets: this.chartData,
      labels: this.getLabels,
      dataChart: {
          labels: ['Февраль 2023', 'Январь 2024', 'Февраль 2024'],
          datasets:[{
            footer: '123123',
            label: 'Data1',
            data: [28,28,28],
            stack: 'Stack 0',
            backgroundColor: '#82BF00',
            borderWidth: {
              top: 4
            },
            borderColor: 'transparent',
            borderRadius: {
              topLeft: 10,
              topRight: 10,
            },
            borderSkipped: false,
            datalabels: {
              labels: {
                value: {
                  color: 'white'
                }
              }
            }
          },
            {
            label: 'Data2',
            data: [23,23,23],
            stack: 'Stack 0',
            backgroundColor: '#9AC2FF',
            borderWidth: {
              bottom: 4
            },
            borderColor: 'transparent',
            borderRadius: {
              topLeft: 10,
              topRight: 10,
              bottomLeft: 6,
              bottomRight: 6
            },
            borderSkipped: false,
            datalabels: {
              labels: {
                value: {
                  color: '#252628'
                }
              }
            }
          }],


      },
      chartOptions: {
        onHover: (event, chartElement) => {
            if(chartElement.length === 1){
              event.native.target.style.cursor = 'pointer'
            }
          if(chartElement.length === 0){
            event.native.target.style.cursor = 'default'
          }
        },
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            enabled: false,
            external: function(context){

              let tooltipEl = document.getElementById('chartjs-tooltip')

              if(!tooltipEl){
                tooltipEl = document.createElement('div')
                tooltipEl.id = 'chartjs-tooltip'
                tooltipEl.innerHTML = '<div></div>'
                document.body.querySelector('.js--top-twenty-businesses').appendChild(tooltipEl);

              }

              const tooltipModel = context.tooltip;
              if(tooltipModel.opacity === 0){
                tooltipEl.style.opacity = 0;
                tooltipEl.style.visibility = 'hidden'
                return;
              }

              tooltipEl.classList.remove('above', 'below', 'no-transform')
              if (tooltipModel.yAlign) {
                tooltipEl.classList.add(tooltipModel.yAlign)
              } else {
                tooltipEl.classList.add('no-transform')
              }
              const dataId = tooltipModel.dataPoints[0].dataIndex
              const dataArray = tooltipModel.dataPoints[0].dataset.topics[dataId]
              const name = dataArray.product_type ? dataArray.product_type : dataArray.mortgage_type
              function changeState () {
                tooltipEl.style.opacity = 0;
                tooltipEl.style.visibility = 'hidden'
                document.querySelector('.chartjs-popup__button').removeEventListener('click', changeState)
              }
              if (tooltipModel.body){
                let innerHtml
                let title = tooltipModel.title[0].split(',').join(' ')
                if(document.documentElement.clientWidth >= 767){
                  innerHtml = '<p class="bar" style="border-radius: 4px; font-family: Gilroy-Medium, Arial, sans-serif;width: max-content; background: '+dataArray.color+'; padding: 1px 6px; margin-bottom: 9px; font-size: 12px; line-height: 16px">'+ title+'</p>' + '<h4 style=" margin-bottom: 8px; font-size: 16px; line-height: 24px; font-family: Gilroy-SemiBold, Arial, sans-serif;">'+ name +'</h4>' + '<div style="margin-bottom: 9px; display: flex; justify-content: space-between">' +
                      '<p style="max-width: 117px;  font-size: 12px; line-height: 16px; font-family: Gilroy-Medium, Arial, sans-serif;">' +
                      'Количество выданных кредитов'
                      + '</p> <p style="max-width: 117px; font-family: Gilroy-SemiBold, Arial, sans-serif; font-size: 16px; line-height: 24px;">'+dataArray.quantity+' тыс. шт</p></div>'+ '<div style="display: flex; justify-content: space-between"><p style="color:#6D6D6D;font-family: Gilroy-Medium, Arial, sans-serif; font-size: 12px; line-height: 16px;max-width: 117px;  font-size: 12px; line-height: 16px;">' +
                      'Объем выданных кредитов'
                      + '</p> <p style="max-width: 117px; font-family: Gilroy-Medium, Arial, sans-serif;  font-size: 12px; line-height: 16px; color:#6D6D6D;" >'+dataArray.volume+' млрд ₽</p></div>'
                  tooltipEl.innerHTML = innerHtml
                } else {
                  innerHtml = '<div class="chartjs-popup" style="background: white;"> <button class="chartjs-popup__button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">\n' +
                      '<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#252628"/>\n' +
                      '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2092 11.2092C11.4882 10.9303 11.9404 10.9303 12.2194 11.2092L16 14.9898L19.7806 11.2092C20.0596 10.9303 20.5118 10.9303 20.7908 11.2092C21.0697 11.4882 21.0697 11.9404 20.7908 12.2194L17.0102 16L20.7908 19.7806C21.0697 20.0596 21.0697 20.5118 20.7908 20.7908C20.5118 21.0697 20.0596 21.0697 19.7806 20.7908L16 17.0102L12.2194 20.7908C11.9404 21.0697 11.4882 21.0697 11.2092 20.7908C10.9303 20.5118 10.9303 20.0596 11.2092 19.7806L14.9898 16L11.2092 12.2194C10.9303 11.9404 10.9303 11.4882 11.2092 11.2092Z" fill="#252628"/>\n' +
                      '</svg></button>'+'<p class="bar" style="width: max-content; background: '+dataArray.color+'; padding: 1px 6px; margin-bottom: 9px; font-size: 12px; line-height: 16px">'+ title+'</p>' + '<h4 style=" margin-bottom: 8px; font-size: 18px; line-height: 24px">'+name +'</h4>' + '<div style="margin-bottom: 9px; display: flex; justify-content: space-between">' +
                      '<p style="max-width: 117px;  font-size: 12px; line-height: 16px;">' +
                      'Количество выданных кредитов'
                      + '</p> <p style="max-width: 117px;  font-size: 16px; line-height: 24px;">'+dataArray.quantity+' тыс. шт</p></div>'+ '<div style="display: flex; justify-content: space-between"><p style="max-width: 117px;  font-size: 12px; line-height: 16px;">' +
                      'Объем выданных кредитов'
                      + '</p> <p style="max-width: 117px;  font-size: 16px; line-height: 24px;" >'+dataArray.volume+' млрд ₽</p></div>'+ '</div>'
                  tooltipEl.innerHTML = innerHtml
                  document.querySelector('.chartjs-popup__button').addEventListener('click', changeState)
                }


              }

              const position = context.chart.canvas.getBoundingClientRect()

              tooltipEl.style.opacity = 1
              tooltipEl.style.visibility = 'visible'
              if(document.documentElement.clientWidth >= 767) {
                tooltipEl.style.position = 'absolute'
                if (tooltipModel.caretX > tooltipEl.offsetWidth ? tooltipEl.offsetWidth : 0) {
                  tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX - tooltipEl.offsetWidth + 'px'
                } else {
                  tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px'
                }
                if ((tooltipModel.caretY + tooltipEl.offsetHeight) > 800) {
                  tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY - tooltipEl.offsetHeight + 'px'
                } else {
                  tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
                }
                tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px'
                tooltipEl.style.pointerEvents = 'none'
              } else {
                tooltipEl.style.position = 'fixed'
                tooltipEl.style.left = 0
                tooltipEl.style.top = 0
                tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px'
              }
            }
          },
          legend: false,
          datalabels: {
            labels: {
              value: {
                anchor: 'center',
                align: 'center',
                formatter: (value,context) => {
                  //console.log(context.dataset.topics[context.dataIndex].quantity_percent)
                  //console.log(context.dataset.maxNumber)
                  if(Number(context.dataset.topics[context.dataIndex].quantity_percent) > Number(context.dataset.maxNumber)){
                    return context.dataset.topics[context.dataIndex].quantity_percent+'%'
                  }
                  return ''
                }
              },
              title: {
                anchor: 'end',
                color: '#252628',
                align: top,
                font: {
                  size: document.documentElement.clientWidth >= 767 ? 20 : 14,
                  family: 'Gilroy-Medium, Arial, sans-serif'
                },
                formatter: (value, context) => {
                  if (context.datasetIndex === context.chart.data.datasets.length - 1) {
                    // console.log([Object.values(context.chart.data.datasets[context.dataIndex].countMax)[context.dataIndex].sum_quantity, '', ''])
                    return [Object.values(context.chart.data.datasets[2].countMax).reverse()[context.dataIndex].sum_quantity, '', '']
                  }
                  return ''
                }
              }
            }
          },
        },

        responsive: true,
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false,
              borderColor:  '#999999'
            },
            ticks:{
              font:{
                size: 12
              },
              color: '#999999'
            }
          },
          y: {
            stacked: true,
            grid: {
              display: false,
              borderColor:  '#999999'
            },
            title: {
              display: false
            },
            max: () => this.maxCount * 1.2,
            beginAtZero: true,
            ticks: {
              color: '#999999',
              backdropPadding: 10,
              font:{
                size: 12
              },
              align: 'end',
              callback(val,index,ticks) {
                const maxCount = Math.max.apply(null, ticks.map((a) => a.value))
                if(val === maxCount){
                  return window.innerWidth >= 767 ? ['тысяч',' кредитов', ' '] : ['тысяч',' кред.', ' ']
                } else {
                  return val
                }
              },
            }
          }
        }
      }
    };
  },
  computed: {
    isDesktop() {
      return document.documentElement.clientWidth >= 767;
    },
    chartHeight() {
      return (this.isDesktop) ? 715 : 600;
    },
    chartWidth() {
      return (this.isDesktop) ? 500 : 500;
    },
    getLabels(){
      if(this.chartData){
        const result = []
        Object.values(this.chartData).forEach((item) => {
          result.push(item.month + ' ' + item.year)
        })
        return result
      }
      return []
    },
  }
};
</script>
